import getClient from "./getClient";

export default function onAuthStateChange(callback) {
  return getClient().auth.onAuthStateChange(callback);
}
